const prepareMessages = (jsonData) => {
    // Create a new object to store the transformed data
    const transformedData = {};

    // Iterate over each key-value pair in the JSON data
    for (const [key, value] of Object.entries(jsonData)) {
        // Replace words starting with ':' in the key
        const transformedKey = key.replace(/:\w+/g, match => `{${match.slice(1)}}`);

        // Replace words starting with ':' in the value
        const transformedValue = value.replace(/:\w+/g, match => `{${match.slice(1)}}`);

        // Add the transformed key-value pair to the new object
        transformedData[transformedKey] = transformedValue;
    }

    return transformedData;
}

const supportedLocales = () => {
    return {
        en: require('../lang/en.json'),
        pl: require('../lang/pl.json'),
        de: require('../lang/de.json'),
        da: require('../lang/da.json'),
    }
}

const translationStrings = {};

for (const [locale, json] of Object.entries(supportedLocales())) {
    translationStrings[locale] = prepareMessages(json)
}

export default translationStrings;